import Vue from 'vue'
import Router from 'vue-router'

// const Foo = () => import('./Foo.vue')
const Wp_jd_data = () => import('./components/pages/Wp_jd_data')
const Wp_jd_select = () => import('./components/pages/Wp_jd_select')
const Wp_jd_changelink = () => import('./components/pages/Wp_jd_changelink')
const Wp_jd_my = () => import('./components/pages/Wp_jd_my')
const Wp_jd_order_flow = () => import('./components/pages/Wp_jd_order_flow')
const Wp_jd_events = () => import('./components/pages/Wp_jd_events')
const Wp_test = () => import('./components/pages/Wp_test')
const Wp_jd_help = () => import('./components/pages/Wp_jd_help')
const Wp_c_test = () => import('./components/pages/Wp_c_test')
const Wp_jd_home = () => import('./components/pages/Wp_jd_home')
const Wp_jd_home_simple = () => import('./components/pages/Wp_jd_home_simple')
const Wp_jd_home_test = () => import('./components/pages/Wp_jd_home_test')
const Wp_jd_activity = () => import('./components/pages/Wp_jd_activity')
const Wp_jd_gift = () => import('./components/pages/Wp_jd_gift')

const Wp_tb_select = () => import('./components/tb/pages/Wp_tb_select')
const Wp_all_search_page = () => import('./components/pages/Wp_all_search_page')
const Wp_waimai = () => import('./components/pages/Wp_waimai')
const Wp_mt_share_page = () => import('./components/meituan/pages/Wp_mt_share_page')
const Wp_mt_order_page = () => import('./components/meituan/pages/Wp_mt_order_page')
const Wp_tb_order_page = () => import('./components/tb/pages/Wp_tb_order_page')
const Wp_pdd_select = () => import('./components/pdd/pages/Wp_pdd_select')
const Wp_pdd_order_page = () => import('./components/pdd/pages/Wp_pdd_order_page')

const JdSelectSku = () => import('./components/pages_user/JdSelectSku')
const Wp_login = () => import('./components/pages_childs/Wp_login')
const Wp_my_pay_data_new = () => import('./components/pages_childs/Wp_my_pay_data_new')
const Wp_my_modify_password = () => import('./components/pages_childs/Wp_my_modify_password')
const Wp_jd_request = () => import('./components/pages_childs/Wp_jd_request')
const Wp_my_child_member = () => import('./components/pages_childs/Wp_my_child_member')
const Wp_my_update_bind_phone = () => import('./components/pages_childs/Wp_my_update_bind_phone')
const Wp_reset_password = () => import('./components/pages_childs/Wp_reset_password')
const Wp_my_change_account = () => import('./components/pages_childs/Wp_my_change_account')
const Wp_jd_article = () => import('./components/pages_childs/Wp_jd_article')
const Wp_jd_content = () => import('./components/pages_childs/Wp_jd_content')
const Wp_order_count_detail_page = () => import('./components/pages_childs/Wp_order_count_detail_page')
const Wp_jd_pop_activities_page = () => import('./components/pages_childs/Wp_jd_pop_activities_page')
const Wp_jd_sku_detail_page = () => import('./components/pages_childs/Wp_jd_sku_detail_page')
const Wp_jd_action_info = () => import('./components/pages_childs/Wp_jd_action_info')
const Wp_jd_action_list = () => import('./components/pages_childs/Wp_jd_action_list')
const Wp_search_page = () => import('./components/pages_childs/Wp_search_page')
const Wp_robot_tools = () => import('./components/pages_childs/Wp_robot_tools')
const Wp_order_count_new = () => import('./components/pages_childs/Wp_order_count_new')
const Wp_tb_order_count_detail_page = () => import('./components/tb/pages_childs/Wp_tb_order_count_detail_page')
const Wp_tb_pay_data = () => import('./components/tb/pages_childs/Wp_tb_pay_data')
const Wp_pdd_order_count_detail_page = () => import('./components/pdd/pages_childs/Wp_pdd_order_count_detail_page')
const Wp_pdd_pay_data = () => import('./components/pdd/pages_childs/Wp_pdd_pay_data')
const Wp_order_count_self_detail_page = () => import('./components/pages_childs/Wp_order_count_self_detail_page')
const Wp_mt_order_count_detail_page = () => import('./components/meituan/pages_childs/Wp_mt_order_count_detail_page')
const Wp_mt_pay_data = () => import('./components/meituan/pages_childs/Wp_mt_pay_data')
const Wp_message_like_weixin = () => import('./components/pages_childs/Wp_message_like_weixin')
const Wp_search_model_page = () => import('./components/pages_childs/Wp_search_model_page')

const Wp_wx_public_regist = () => import('./components/pages_wx_public/Wp_wx_public_regist')
const Wp_hm_config = () => import('./components/pages_hm/Wp_hm_config')
const Wp_order_count = () => import('./components/pages_childs/Wp_order_count')
const Wp_mini_config = () => import('./components/pages_mini_app/Wp_mini_config')
const Wp_mini_my = () => import('./components/pages_mini_app/Wp_mini_my')
const Wp_mini_login = () => import('./components/pages_mini_app/Wp_mini_login')
const Wp_mini_super_login = () => import('./components/pages_mini_app/Wp_mini_super_login')
const Wp_mini_upgrade = () => import('./components/pages_mini_app/Wp_mini_upgrade')
const Wp_mini_guide = () => import('./components/pages_mini_app/Wp_mini_guide')
const Wp_mini_member = () => import('./components/pages_mini_app/Wp_mini_member')
const Wp_mini_event = () => import('./components/pages_mini_app/Wp_mini_event')
const Wp_mini_member_fans = () => import('./components/pages_mini_app/Wp_mini_member_fans')
const Wp_jd_qa = () => import('./components/pages_nologin/Wp_jd_qa')
const Wp_jd_course = () => import('./components/pages_nologin/Wp_jd_course')
const Wp_home_module_page = () => import('./components/custom_model/Wp_home_module_page')
const Wp_home_module_webview = () => import('./components/custom_model/Wp_home_module_webview')

import Wp_mini_member_active_value_detail from './components/pages_mini_app/Wp_mini_member_active_value_detail'

import Wp_video_page from './components/custom/Wp_video_page'

import PrivacyPage from './components/pages_nologin/PrivacyPage'
import Business from './components/pages_nologin/Business'
import Support from './components/pages_nologin/Support'

Vue.use(Router)

const routes = [
  {
    path: '*',
    redirect: 'select',
    // redirect: config.project ==='client'? 'home_s' : 'select',
  },
  {
    name: 'data',
    component: Wp_jd_data,
    meta: {
      title: '数据',
    }
  },
  {
    name: 'data1',
    component: Wp_order_count_new,
    meta: {
      title: '预估收入',
    }
  },
  {
    name: 'count_detail_page',
    component: Wp_order_count_detail_page,
    meta: {
      title: '我的总预估收入详情',
    }
  },
  {
    name: 'count_self_detail_page',
    component: Wp_order_count_self_detail_page,
    meta: {
      title: '我的推广预估收入详情',
    }
  },
  {
    name: 'data2',
    component: Wp_jd_order_flow,
    meta: {
      title: '订单数据',
    }
  },
  {
    name: 'data3',
    component: Wp_my_child_member,
    meta: {
      title: '代理数据',
    }
  },
  {
    name: 'select',
    component: Wp_jd_select,
    meta: {
      title: '首页',
      // keepAlive: false // 不需要缓存
    }
  },
  {
    name: 'changelink',
    component: Wp_jd_changelink,
    meta: {
      title: '转链',
    }
  },
  {
    name: 'flow',
    component: Wp_jd_order_flow,
    meta: {
      title: '订单',
    }
  },
  {
    name: 'my',
    component: Wp_jd_my,
    meta: {
      title: '我的',
    }
  },
  {
    name: 'login',
    component: Wp_login,
    meta: {
      title: '登录',
    }
  },
  {
    name: 'top',
    component: JdSelectSku,
    meta: {
      title: 'Top',
    }
  },
  {
    name: 'events',
    component: Wp_jd_events,
    meta: {
      title: '京东活动',
    }
  },
  {
    name: 'wx_public_regist',
    component: Wp_wx_public_regist,
    meta: {
      title: '新超级会员注册',
    }
  },
  {
    name: 'paydata',
    component: Wp_my_pay_data_new,
    meta: {
      title: '提款',
    }
  },
  {
    name: 'modify_password',
    component: Wp_my_modify_password,
    meta: {
      title: '修改密码',
    }
  },
  {
    name: 'update_phone',
    component: Wp_my_update_bind_phone,
    meta: {
      title: '手机号[修改/绑定]',
    }
  },
  {
    name: 'change_account',
    component: Wp_my_change_account,
    meta: {
      title: '切换账号',
    }
  },
  {
    name: 'reset_password',
    component: Wp_reset_password,
    meta: {
      title: '重置密码',
    }
  },
  {
    name: 'help',
    component: Wp_jd_help,
    meta: {
      title: '帮助',
    }
  },
  {
    name: 'request',
    component: Wp_jd_request,
    meta: {
      title: '申请发品',
    }
  },
  {
    name: 'hm_config',
    component: Wp_hm_config,
    meta: {
      title: '',
    }
  },
  {
    name: 'mini_config',
    component: Wp_mini_config,
    meta: {
      title: '',
    }
  },
  {
    name: 'mini_login',
    component: Wp_mini_login,
    meta: {
      title: '',
    }
  },
  {
    name: 'super_login',
    component: Wp_mini_super_login,
    meta: {
      title: '',
    }
  },
  {
    name: 'mini_my',
    component: Wp_mini_my,
    meta: {
      title: '',
    }
  },
  {
    name: 'mini_event',
    component: Wp_mini_event,
    meta: {
      title: '发现',
    }
  },
  {
    name: 'mini_member',
    component: Wp_mini_member,
    meta: {
      title: '万品京选·会员',
    }
  },
  {
    name: 'mini_member_fans',
    component: Wp_mini_member_fans,
    meta: {
      title: '我的粉丝',
    }
  },
  {
    name: 'mini_active_value',
    component: Wp_mini_member_active_value_detail,
    meta: {
      title: '活跃值',
    }
  },
  {
    name: 'mini_guide',
    component: Wp_mini_guide,
    meta: {
      title: '攻略',
    }
  },
  {
    name: 'mini_upgrade',
    component: Wp_mini_upgrade,
    meta: {
      title: '建群升级',
    }
  },
  {
    name: 'article',
    alias: '/article/article',
    component: Wp_jd_article,
    meta: {
      title: '目录',
    }
  },
  {
    name: 'content',
    alias: '/article/content',
    component: Wp_jd_content,
    meta: {
      title: '详情',
    }
  },
  {
    name: '/test/test',
    path: '/test/test',
    component: Wp_test,
    meta: {
      title: 'Wp_test',
    }
  },
  {
    name: 'c_test',
    component: Wp_c_test,
    meta: {
      title: '组件测试',
    }
  },
  {
    name: 'qa',
    alias: '/article/qa',
    component: Wp_jd_qa,
    meta: {
      title: '常见问题',
    }
  },
  {
    name: 'course',
    alias: '/article/course',
    component: Wp_jd_course,
    meta: {
      title: '课程',
    }
  },
  {
    name: 'pop_activities_page',
    component: Wp_jd_pop_activities_page,
    meta: {
      title: '',
    }
  },
  {
    name: 'action_info',
    component: Wp_jd_action_info,
    meta: {
      title: '详情',
    }
  },
  {
    name: 'action_list',
    component: Wp_jd_action_list,
    meta: {
      title: '活动列表',
    }
  },
  {
    name: 'home',
    component: Wp_jd_home,
    meta: {
      title: '',
    }
  },
  {
    name: 'home_s',
    component: Wp_jd_home_simple,
    meta: {
      title: '',
    }
  },
  {
    name: 'home_test',
    component: Wp_jd_home_test,
    meta: {
      title: 'HomeTest',
    }
  },
  {
    name: 'home_module_page',
    component: Wp_home_module_page,
    meta: {
      title: '',
    }
  },
  {
    name: 'home_module_webview',
    component: Wp_home_module_webview,
    meta: {
      title: '',
    }
  },
  {
    name: 'sku_detail',
    component: Wp_jd_sku_detail_page,
    meta: {
      title: '',
    }
  },
  {
    name: 'jump',
    component: Wp_jd_select,
    meta: {
      title: '',
      // keepAlive: false // 不需要缓存
    }
  },
  {
    name: 'search_page',
    component: Wp_search_page,
    meta: {
      title: '搜索',
    }
  },
  {
    name: 'robot_tools',
    component: Wp_robot_tools,
    meta: {
      title: '助理工具',
    }
  },
  {
    name: 'select_tb',
    component: Wp_tb_select,
    meta: {
      title: '选品tb',
    }
  },
  {
    name: 'order_tb',
    component: Wp_tb_order_page,
    meta: {
      title: '订单tb',
    }
  },
  {
    name: 'count_detail_page_tb',
    component: Wp_tb_order_count_detail_page,
    meta: {
      title: '我的总预估收入详情',
    }
  },
  {
    name: 'paydata_tb',
    component: Wp_tb_pay_data,
    meta: {
      title: '提款',
    }
  },
  {
    name: 'select_pdd',
    component: Wp_pdd_select,
    meta: {
      title: '选品pdd',
    }
  },
  {
    name: 'order_pdd',
    component: Wp_pdd_order_page,
    meta: {
      title: '订单pdd',
    }
  },
  {
    name: 'count_detail_page_pdd',
    component: Wp_pdd_order_count_detail_page,
    meta: {
      title: '我的总预估收入详情',
    }
  },
  {
    name: 'paydata_pdd',
    component: Wp_pdd_pay_data,
    meta: {
      title: '提款',
    }
  },
  {
    name: 'all_search',
    component: Wp_all_search_page,
    meta: {
      title: '选品·搜索',
    }
  },
  {
    name: 'video_page',
    component: Wp_video_page,
    meta: {
      title: '视频播放',
    }
  },
  {
    name: 'waimai',
    component: Wp_waimai,
    meta: {
      title: '领外卖红包',
    }
  },
  {
    name: 'mt_share',
    component: Wp_mt_share_page,
    meta: {
      title: '美团领红包',
    }
  },
  {
    name: 'order_mt',
    component: Wp_mt_order_page,
    meta: {
      title: '订单pdd',
    }
  },
  {
    name: 'count_detail_page_mt',
    component: Wp_mt_order_count_detail_page,
    meta: {
      title: '我的总预估收入详情',
    }
  },
  {
    name: 'paydata_mt',
    component: Wp_mt_pay_data,
    meta: {
      title: '提款',
    }
  },
  {
    name: 'message_like_wx',
    alias: '/hot',
    component: Wp_message_like_weixin,
    meta: {
      title: '今日热推',
    }
  },
  {
    name: 'privacy',
    component: PrivacyPage,
    meta: {
      title: '隐私政策',
    }
  },
  {
    name: 'business',
    component: Business,
    meta: {
      title: '商务合作',
    }
  },
  {
    name: 'support',
    component: Support,
    meta: {
      title: '技术支持',
    }
  },
  {
    name: 'activity_list',
    meta: {
      title: '京东官方活动',
    },
    component: Wp_jd_activity
  },
  {
    name: 'search_model_page',
    component: Wp_search_model_page,
    meta: {
      title: '搜索',
    }
  },

  {
    name: 'gift',
    component: Wp_jd_gift,
    meta: {
      title: '礼金',
    }
  },

]
// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
})

const router = new Router({
  // mode:'history',
  routes
})

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
  next()
})

export {
  router
}
